"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialsFromName = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var AvatarAdd_1 = __importDefault(require("./AvatarAdd"));
var AvatarGroup_1 = __importDefault(require("./AvatarGroup"));
var AvatarProfile_1 = __importDefault(require("./AvatarProfile"));
var BaseAvatarInternal_1 = __importDefault(require("./BaseAvatarInternal"));
var OnlineIndicator_1 = __importDefault(require("./OnlineIndicator"));
var styles_1 = require("./styles");
var getInitialsFromName = function (name) {
    if (!name) {
        return '';
    }
    var nameParts = name.split(' ');
    if (nameParts.length === 1) {
        return nameParts[0].charAt(0).toUpperCase();
    }
    return ("" + nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
};
exports.getInitialsFromName = getInitialsFromName;
var Avatar = function (props) {
    var _a = props.size, size = _a === void 0 ? 'md' : _a, rest = __rest(props, ["size"]);
    return (react_1.jsx(BaseAvatarInternal_1.default, __assign({}, rest, { wrapperSize: styles_1.sizesMap[size].root, fontSize: styles_1.sizesMap[size].font, iconSize: styles_1.sizesMap[size].iconFont, indicatorSize: styles_1.sizesMap[size].indicator })));
};
exports.default = Object.assign(Avatar, {
    Add: AvatarAdd_1.default,
    Group: AvatarGroup_1.default,
    OnlineIndicator: OnlineIndicator_1.default,
    Profile: AvatarProfile_1.default,
});
